import styled from 'styled-components';
import { IThemeProvider } from '../../../../../../../styles/theme';

export const AnimatedWrapper = styled.div<{ isExpanded: boolean }>`
  display: grid;
  grid-template-rows: ${({ isExpanded }) => (isExpanded ? '1fr' : '0fr')};
  opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
  transition:
    grid-template-rows 0.3s ease,
    opacity 0.3s ease;
`;

export const Collapsible = styled.div`
  overflow: hidden;
  min-height: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 0 0 8px 8px;
  border-bottom: 1px solid rgb(192, 192, 192);
  margin-bottom: 12px;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
  `}
`;

export const Container = styled.div`
  padding: 20px 0 0 0;
  width: 100%;

  ${({ theme }: IThemeProvider) => `
    border-top: 1px solid ${theme.colors.neutral.primary[30]};
  `}
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-left: 4rem;
  font-style: italic;
`;
